import { createContext } from "react";

export interface FeatureFlagContextType {
  featureFlags: {
    checklist: boolean;
    sectionWritingVersionSelector: boolean;
    framerPlugin: boolean;
  };
}

const defaultFeatureFlagContext: FeatureFlagContextType = {
  featureFlags: {
    sectionWritingVersionSelector: false,
    checklist: false,
    framerPlugin: false,
  },
};

const FeatureFlagContext = createContext<FeatureFlagContextType>(
  defaultFeatureFlagContext,
);

export default FeatureFlagContext;
